module.exports = __webpack_public_path__ + "static/media/firebreaks.4bc08931.jpg";